
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdvancedSearchCreatedResponse,
  AdvancedSearchResponse,
  AdvancedSearchResultsResponse,
  ClearFreelancerSelectionRequest,
  CreateAdvancedSearchFromPromptRequest,
  DetectPromptEntitiesRequest,
  DetectedPromptEntities,
  FamilyWithCategories,
  RejectFreelancersRequest,
  SelectFreelancersRequest,
  TrackAdvancedSearchDisplayedProfilesRequest,
  UnselectFreelancersRequest,
  UpdateAdvancedSearchRequest,
  ValidationError,
} from '../models';
import {
    AdvancedSearchCreatedResponseFromJSON,
    AdvancedSearchCreatedResponseToJSON,
    AdvancedSearchResponseFromJSON,
    AdvancedSearchResponseToJSON,
    AdvancedSearchResultsResponseFromJSON,
    AdvancedSearchResultsResponseToJSON,
    ClearFreelancerSelectionRequestFromJSON,
    ClearFreelancerSelectionRequestToJSON,
    CreateAdvancedSearchFromPromptRequestFromJSON,
    CreateAdvancedSearchFromPromptRequestToJSON,
    DetectPromptEntitiesRequestFromJSON,
    DetectPromptEntitiesRequestToJSON,
    DetectedPromptEntitiesFromJSON,
    DetectedPromptEntitiesToJSON,
    FamilyWithCategoriesFromJSON,
    FamilyWithCategoriesToJSON,
    RejectFreelancersRequestFromJSON,
    RejectFreelancersRequestToJSON,
    SelectFreelancersRequestFromJSON,
    SelectFreelancersRequestToJSON,
    TrackAdvancedSearchDisplayedProfilesRequestFromJSON,
    TrackAdvancedSearchDisplayedProfilesRequestToJSON,
    UnselectFreelancersRequestFromJSON,
    UnselectFreelancersRequestToJSON,
    UpdateAdvancedSearchRequestFromJSON,
    UpdateAdvancedSearchRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AddFreelancersToSelectionRequest {
    advancedSearchId: string;
    selectFreelancersRequest: SelectFreelancersRequest;
}

export interface ClearSelectionRequest {
    advancedSearchId: string;
    clearFreelancerSelectionRequest: ClearFreelancerSelectionRequest;
}

export interface CreateAdvancedSearchFromPromptOperationRequest {
    createAdvancedSearchFromPromptRequest: CreateAdvancedSearchFromPromptRequest;
}

export interface DetectPromptEntitiesOperationRequest {
    detectPromptEntitiesRequest: DetectPromptEntitiesRequest;
}

export interface FindAdvancedSearchByBriefIdRequest {
    briefId: string;
}

export interface InitiateSignupWorkflowRequest {
    briefId: string;
    pageSource?: string;
}

export interface PerformSearchRequest {
    briefId: string;
}

export interface RejectFreelancersOperationRequest {
    advancedSearchId: string;
    rejectFreelancersRequest: RejectFreelancersRequest;
}

export interface RemoveFreelancersFromSelectionRequest {
    advancedSearchId: string;
    unselectFreelancersRequest: UnselectFreelancersRequest;
}

export interface TrackDisplayedProfilesRequest {
    briefId: string;
    trackAdvancedSearchDisplayedProfilesRequest: TrackAdvancedSearchDisplayedProfilesRequest;
}

export interface UpdateAdvancedSearchByIdRequest {
    advancedSearchId: string;
    updateAdvancedSearchRequest: UpdateAdvancedSearchRequest;
}

/**
 * 
 */
export class AdvancedSearchApi extends runtime.BaseAPI {

    /**
     * Add freelancer profiles to the selection
          */
    async addFreelancersToSelectionRaw(requestParameters: AddFreelancersToSelectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling addFreelancersToSelection().'
            );
        }

        if (requestParameters['selectFreelancersRequest'] == null) {
            throw new runtime.RequiredError(
                'selectFreelancersRequest',
                'Required parameter "selectFreelancersRequest" was null or undefined when calling addFreelancersToSelection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/{advancedSearchId}/selection/select`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectFreelancersRequestToJSON(requestParameters['selectFreelancersRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Add freelancer profiles to the selection
          */
    async addFreelancersToSelection(requestParameters: AddFreelancersToSelectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.addFreelancersToSelectionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Clear the selection
          */
    async clearSelectionRaw(requestParameters: ClearSelectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling clearSelection().'
            );
        }

        if (requestParameters['clearFreelancerSelectionRequest'] == null) {
            throw new runtime.RequiredError(
                'clearFreelancerSelectionRequest',
                'Required parameter "clearFreelancerSelectionRequest" was null or undefined when calling clearSelection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/{advancedSearchId}/selection/clear`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClearFreelancerSelectionRequestToJSON(requestParameters['clearFreelancerSelectionRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Clear the selection
          */
    async clearSelection(requestParameters: ClearSelectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.clearSelectionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Create Advanced Search From Prompt
          */
    async createAdvancedSearchFromPromptRaw(requestParameters: CreateAdvancedSearchFromPromptOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchCreatedResponse>> {
        if (requestParameters['createAdvancedSearchFromPromptRequest'] == null) {
            throw new runtime.RequiredError(
                'createAdvancedSearchFromPromptRequest',
                'Required parameter "createAdvancedSearchFromPromptRequest" was null or undefined when calling createAdvancedSearchFromPrompt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdvancedSearchCreatedResponse>({
            path: `/search/api/advanced/prompt`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAdvancedSearchFromPromptRequestToJSON(requestParameters['createAdvancedSearchFromPromptRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchCreatedResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Create Advanced Search From Prompt
          */
    async createAdvancedSearchFromPrompt(requestParameters: CreateAdvancedSearchFromPromptOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchCreatedResponse> {
        const response = await this.createAdvancedSearchFromPromptRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Runs the Named Entity Recognition pipeline on a free-text brief prompt and returns the set of recognized entity types (location, job title, experience, industry, skills). Used to render real-time hints to the user while typing. 
     * Extract named entities from a brief prompt (NER)
          */
    async detectPromptEntitiesRaw(requestParameters: DetectPromptEntitiesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<DetectedPromptEntities>> {
        if (requestParameters['detectPromptEntitiesRequest'] == null) {
            throw new runtime.RequiredError(
                'detectPromptEntitiesRequest',
                'Required parameter "detectPromptEntitiesRequest" was null or undefined when calling detectPromptEntities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<DetectedPromptEntities>({
            path: `/search/api/advanced/prompt-entities`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DetectPromptEntitiesRequestToJSON(requestParameters['detectPromptEntitiesRequest']),
        }, initOverrides);

        if (response._data) { response._data=DetectedPromptEntitiesFromJSON(response._data); }
        return response;
    }

    /**
     * Runs the Named Entity Recognition pipeline on a free-text brief prompt and returns the set of recognized entity types (location, job title, experience, industry, skills). Used to render real-time hints to the user while typing. 
     * Extract named entities from a brief prompt (NER)
          */
    async detectPromptEntities(requestParameters: DetectPromptEntitiesOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<DetectedPromptEntities> {
        const response = await this.detectPromptEntitiesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get existing advanced search by brief Id
          */
    async findAdvancedSearchByBriefIdRaw(requestParameters: FindAdvancedSearchByBriefIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling findAdvancedSearchByBriefId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/brief/{briefId}`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get existing advanced search by brief Id
          */
    async findAdvancedSearchByBriefId(requestParameters: FindAdvancedSearchByBriefIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.findAdvancedSearchByBriefIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Initiate Signin/Signup workflow for unloggedAdvancedSearch
          */
    async initiateSignupWorkflowRaw(requestParameters: InitiateSignupWorkflowRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling initiateSignupWorkflow().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSource'] != null) {
            queryParameters['pageSource'] = requestParameters['pageSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/api/advanced/brief/{briefId}/signup-client`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Initiate Signin/Signup workflow for unloggedAdvancedSearch
          */
    async initiateSignupWorkflow(requestParameters: InitiateSignupWorkflowRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.initiateSignupWorkflowRaw(requestParameters, initOverrides);
    }

    /**
     * List all families with categories
          */
    async listFamiliesWithCategoriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FamilyWithCategories>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FamilyWithCategories>>({
            path: `/search/api/advanced/families`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FamilyWithCategoriesFromJSON);
        return response;
    }

    /**
     * List all families with categories
          */
    async listFamiliesWithCategories(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FamilyWithCategories>> {
        const response = await this.listFamiliesWithCategoriesRaw(initOverrides);
        return response._data;
    }

    /**
     * Find profiles for given advanced search by briefId
          */
    async performSearchRaw(requestParameters: PerformSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResultsResponse>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling performSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdvancedSearchResultsResponse>({
            path: `/search/api/advanced/brief/{briefId}/search`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResultsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Find profiles for given advanced search by briefId
          */
    async performSearch(requestParameters: PerformSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResultsResponse> {
        const response = await this.performSearchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Reject freelancer profiles from the selection
          */
    async rejectFreelancersRaw(requestParameters: RejectFreelancersOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling rejectFreelancers().'
            );
        }

        if (requestParameters['rejectFreelancersRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectFreelancersRequest',
                'Required parameter "rejectFreelancersRequest" was null or undefined when calling rejectFreelancers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/{advancedSearchId}/search/reject-freelancers`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectFreelancersRequestToJSON(requestParameters['rejectFreelancersRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Reject freelancer profiles from the selection
          */
    async rejectFreelancers(requestParameters: RejectFreelancersOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.rejectFreelancersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Remove freelancer profiles from the selection
          */
    async removeFreelancersFromSelectionRaw(requestParameters: RemoveFreelancersFromSelectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling removeFreelancersFromSelection().'
            );
        }

        if (requestParameters['unselectFreelancersRequest'] == null) {
            throw new runtime.RequiredError(
                'unselectFreelancersRequest',
                'Required parameter "unselectFreelancersRequest" was null or undefined when calling removeFreelancersFromSelection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/{advancedSearchId}/selection/unselect`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UnselectFreelancersRequestToJSON(requestParameters['unselectFreelancersRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Remove freelancer profiles from the selection
          */
    async removeFreelancersFromSelection(requestParameters: RemoveFreelancersFromSelectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.removeFreelancersFromSelectionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update freelancer profiles statistics and contribute to advanced search events
          */
    async trackDisplayedProfilesRaw(requestParameters: TrackDisplayedProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling trackDisplayedProfiles().'
            );
        }

        if (requestParameters['trackAdvancedSearchDisplayedProfilesRequest'] == null) {
            throw new runtime.RequiredError(
                'trackAdvancedSearchDisplayedProfilesRequest',
                'Required parameter "trackAdvancedSearchDisplayedProfilesRequest" was null or undefined when calling trackDisplayedProfiles().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/search/api/advanced/brief/{briefId}/track-displayed-profiles`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TrackAdvancedSearchDisplayedProfilesRequestToJSON(requestParameters['trackAdvancedSearchDisplayedProfilesRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update freelancer profiles statistics and contribute to advanced search events
          */
    async trackDisplayedProfiles(requestParameters: TrackDisplayedProfilesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.trackDisplayedProfilesRaw(requestParameters, initOverrides);
    }

    /**
     * Update one field of an existing advanced search
          */
    async updateAdvancedSearchByIdRaw(requestParameters: UpdateAdvancedSearchByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling updateAdvancedSearchById().'
            );
        }

        if (requestParameters['updateAdvancedSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAdvancedSearchRequest',
                'Required parameter "updateAdvancedSearchRequest" was null or undefined when calling updateAdvancedSearchById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/{advancedSearchId}`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAdvancedSearchRequestToJSON(requestParameters['updateAdvancedSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Update one field of an existing advanced search
          */
    async updateAdvancedSearchById(requestParameters: UpdateAdvancedSearchByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.updateAdvancedSearchByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

}
